// filepath: /c:/Users/andre/Documents/development/demo-react-vis-app/src/reducers/messagesReducer.js
import { createSlice } from '@reduxjs/toolkit';

const messagesSlice = createSlice({
    name: 'messages',
    initialState: [],
    reducers: {
        addMessage: (state, action) => {
            state.push(action.payload);
        },
        clearMessages: (state) => {
            return [];
        },
    },
});

export const { addMessage, clearMessages } = messagesSlice.actions;
export default messagesSlice.reducer;